var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleCardBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 42,
    viewBox: "0 0 72 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 21C71 26.2957 67.313 31.2749 60.952 34.9855C54.6155 38.6817 45.7959 41 36 41C26.2041 41 17.3845 38.6817 11.048 34.9855C4.68702 31.2749 1 26.2957 1 21C1 15.7043 4.68702 10.7251 11.048 7.01454C17.3845 3.31827 26.2041 1 36 1C45.7959 1 54.6155 3.31827 60.952 7.01454C67.313 10.7251 71 15.7043 71 21Z",
    fill: "#EDEEEF",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleCardBubble);
export default __webpack_public_path__ + "static/media/ArticleCardBubble.0bcb9ca8e62e7de12e5b87ca07a5e5df.svg";
export { ForwardRef as ReactComponent };